"use client";

import { Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Begin() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const trustPoints = ["Concierge privacy", "Refined facial balancing", "Complimentary consultation"];
  return <section data-section-id="14736" id="begin-your-journey" className="bg-background text-foreground relative overflow-hidden py-20 md:py-28 px-6 md:px-12">
      {}
      <div aria-hidden="true" className="absolute inset-0 pointer-events-none backdrop-blur-[4px]" />

      <div ref={ref} className="relative max-w-[720px] mx-auto text-center" style={{
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? "translateY(0)" : "translateY(12px)",
      transition: "opacity 700ms cubic-bezier(0.25, 0.1, 0.25, 1), transform 700ms cubic-bezier(0.25, 0.1, 0.25, 1)"
    }}>
        {}
        <p className="font-default text-[0.8125rem] font-bold uppercase tracking-[0.2em] text-primary" style={{
        transition: "opacity 700ms ease-out 120ms"
      }}>
          Your aesthetic evolution
        </p>

        {}
        <h2 className="font-default font-medium mt-8 text-foreground text-[clamp(2rem,3.8vw,3.25rem)] leading-[1.2] tracking-[-0.01em]">
          Refinement that feels{" "}
          <span className="relative inline-block italic font-serif">
            effortless
            <span aria-hidden="true" className="absolute left-0 right-0 block" style={{
            bottom: "-0.18em",
            height: "2px",
            backgroundColor: "var(--primary)",
            borderRadius: "2px",
            transform: isVisible ? "scaleX(1)" : "scaleX(0)",
            transformOrigin: "left center",
            transition: "transform 700ms cubic-bezier(0.25, 0.1, 0.25, 1) 1100ms"
          }} />
          </span>
        </h2>

        {}
        <p className="font-default mt-10 text-[clamp(1.125rem,1.25vw,1.25rem)] leading-[1.7] text-muted-foreground max-w-[560px] mx-auto">
          Experience bespoke facial balancing designed to restore your natural symmetry. 
          <br className="hidden md:block" />
          {" "}Your journey to confidence begins here.
        </p>

        {}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-8">
          <Link to="https://my.portraitcare.com/booking/?business_id=jr3uOp" aria-label="Reach out to Ideal Image Aesthetics">
            <Button className="font-default h-16 px-10 rounded-lg text-base font-medium shadow-md hover:shadow-lg transition-all duration-300 ease-out hover:-translate-y-0.5 bg-primary text-primary-foreground hover:bg-chart-5">
              Schedule your visit
            </Button>
          </Link>

          <Link to="tel:2103380049" className="font-default inline-flex items-center gap-2 text-foreground hover:text-foreground/80 transition-colors duration-200">
            <Phone className="size-4" aria-hidden="true" strokeWidth={1.25} />
            <span className="text-base" style={{
            textDecoration: "underline",
            textDecorationColor: "var(--primary)",
            textUnderlineOffset: "6px",
            textDecorationThickness: "1px"
          }}>
              or call (210) 338-0049
            </span>
          </Link>
        </div>

        {}
        <div className="mt-12 flex flex-wrap items-center justify-center gap-x-5 gap-y-3 text-sm text-muted-foreground">
          {trustPoints.map((point, i) => <div data-index={i} key={point} className="flex items-center gap-5">
              <span className="font-default tracking-[0.01em]">{point}</span>
              {i < trustPoints.length - 1 && <span aria-hidden="true" className="hidden sm:inline-block size-1 rounded-lg bg-border" />}
            </div>)}
        </div>
      </div>
    </section>;
}